<template>
  <svg v-if="pts" :viewBox="`0 0 ${w} ${h}`" :style="{width: w + 'px', direction: 'ltr'}" aria-hidden="true" class="sd-spark">
    <polyline :points="pts" fill="none" :stroke="color" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" opacity=".75" />
  </svg>
</template>
<script>
export default {
  name: 'SdSparkLine',
  props: { values: { type: Array, default: () => [] }, color: { type: String, default: 'var(--sd-green-500)' }, w: { type: Number, default: 96 }, h: { type: Number, default: 24 } },
  computed: {
    pts() {
      const v = this.values.filter((x) => x != null); if (v.length < 2) return ''
      const max = Math.max(...v), min = Math.min(...v), rng = (max - min) || 1
      return v.map((x, i) => `${(i / (v.length - 1)) * this.w},${this.h - 2 - ((x - min) / rng) * (this.h - 5)}`).join(' ')
    },
  },
}
</script>
<style scoped>.sd-spark{display:inline-block;width:auto}</style>
